export default __webpack_public_path__ + "static/media/002.9e1e17a2.webp";